import moment from "moment";
import { mapState } from "vuex";
import http from "../../store/modules/helpers/httpInterceptor";
import {
  DATE_FORMAT_HM,
  DATE_FORMAT_SHORT,
  DATE_FORMAT_V2,
  OT_TYPE_FIXED,
  OT_TYPE_FIXED_CONFIG,
  OT_TYPE_FLEXIBLE,
  OT_TYPE_FIXED_IGNORE,
  OT_TYPE_FIXED_CONFIG_IGNORE,
  OT_TYPE_FLEXIBLE_IGNORE,
  ROLE_PROJECT_PM,
} from "../commons/commonConstant";
import {
  beforeUploadFile,
  convertObjectToParams,
  disableWeekendCommon,
  downloadFile,
  getInfoStaff,
  getMessages,
} from "../commons/commons";

export default {
  name: "OvertimeModal",
  props: {
    visibleModal: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    handleCancel: Function,
    getData: Function,
    data: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      moment,
      formRQ: this.$form.createForm(this, {
        name: "formRQ",
        onValuesChange: this.onValuesChange,
      }),
      formData: {},
      fileList: [],
      timeoutAllStaff: null,
      timeoutStaffByProject: null,
      fetching: false,
      checkEndTime: {
        minutes: 23,
        hours: 59,
      },
      checkStartTime: {
        minutes: 0,
        hours: 0,
      },
      startTime: null,
      endTime: null,
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 19 },
      },
      durations: {
        duration: null,
        startTime: null,
        endTime: null,
      },
      isLoading: false,
      overtimeType: OT_TYPE_FIXED,
      OT_TYPE_FIXED,
      OT_TYPE_FIXED_CONFIG,
      OT_TYPE_FLEXIBLE,
      OT_TYPE_FIXED_IGNORE,
      OT_TYPE_FIXED_CONFIG_IGNORE,
      OT_TYPE_FLEXIBLE_IGNORE,
      roleProject: "",
      projectSelected: {},
      visibleModalOvertime: this.visibleModal,
      projectManagerList: [],
    };
  },
  computed: {
    ...mapState({
      roles: (state) => (state.user.userInfo.roles ? state.user.userInfo.roles : ""),
      allProjectList: (state) => state.application.allProjectList,
      projectListPermission: (state) => state.application.projectListPermission,
      dataOTRequestList: (state) => state.overtime.dataOTRequestList,
      overtimeShift: (state) => state.overtime.overtimeShift,
      otTypeList: (state) => state.application.otTypeList,
      employeeList: (state) => state.application.employeeList,
      userInfo: (state) => state.user.userInfo,
      sameDUStaff: (state) => state.application.sameDUStaff,
      lastTimesheet: (state) => state.application.lastTimesheet,
      employeeByProject: (state) => state.application.employeeByProject,
      timeServer: (state) => state.application.timeServer,
    }),
  },
  created() {
    this.overtimeType = this.userInfo.overtimeType;
    if (this.isEdit) {
      this.handleDataEdit();
    }
    if (this.overtimeType === OT_TYPE_FIXED || this.overtimeType === OT_TYPE_FIXED_IGNORE) {
      this.$store.dispatch("application/getAllProjectList");
      this.getAssignee();
    } else if (
      this.overtimeType === OT_TYPE_FIXED_CONFIG ||
      this.overtimeType === OT_TYPE_FLEXIBLE ||
      this.overtimeType === OT_TYPE_FLEXIBLE_IGNORE ||
      this.overtimeType === OT_TYPE_FIXED_CONFIG_IGNORE
    ) {
      this.$store.dispatch("application/getProjectListPermission", {
        username: this.userInfo.userName,
        projectName: " ",
      });
    }
    // Get Time Server
    this.$store.dispatch("application/getTimeServer");
  },
  mounted() {},
  methods: {
    handleDataEdit() {
      let userSearches = [];
      if (
        this.overtimeType === OT_TYPE_FIXED_CONFIG ||
        this.overtimeType === OT_TYPE_FLEXIBLE ||
        this.overtimeType === OT_TYPE_FIXED_CONFIG_IGNORE ||
        this.overtimeType === OT_TYPE_FLEXIBLE_IGNORE
      ) {
        const {
          title,
          project,
          projectId,
          pms,
          overtimeDate,
          requestType,
          startTime,
          endTime,
          dateType,
          description,
          ccMailList,
          requesterId,
          requester,
          ccMails,
        } = this.data;
        this.formData = {
          title,
          project: projectId,
          OT_date: moment(overtimeDate, DATE_FORMAT_V2),
          category: dateType,
          ot_type: requestType,
          start_time: moment(startTime, DATE_FORMAT_HM),
          end_time: moment(endTime, DATE_FORMAT_HM),
          description,
          staff: [requesterId],
          ccMails: ccMailList ? ccMailList : [],
          projectCode: project && project?.projectCode,
        };
        const pmsUsername = [];
        this.projectSelected.project_id = projectId;
        if (pms && pms.length > 0) {
          pms.forEach((pm) => {
            pmsUsername.push(pm?.username);
          });
          this.onSearchPMList(pmsUsername.join(","));
          this.formData = { ...this.formData, pms: pmsUsername };
        }
        if (ccMails && ccMails.length > 0) {
          ccMails.forEach((user) => userSearches.push(user?.username));
        }
        if (requester) {
          this.onSearchEmployeeByProject(null, 100, true);
        }
        this.checkStartTime = {
          hours: parseInt(moment(startTime, DATE_FORMAT_HM).format("HH")),
          minutes: parseInt(moment(startTime, DATE_FORMAT_HM).format("mm")),
        };
        this.checkEndTime = {
          hours: parseInt(moment(endTime, DATE_FORMAT_HM).format("HH")),
          minutes: parseInt(moment(endTime, DATE_FORMAT_HM).format("mm")),
        };
      } else if (this.overtimeType === OT_TYPE_FIXED || this.overtimeType === OT_TYPE_FIXED_IGNORE) {
        const {
          assignee_ob,
          category,
          description,
          end_time,
          mail_cc,
          mailList,
          ot_date,
          ot_type,
          project_code,
          project_id,
          staff,
          start_time,
          title,
        } = this.data;
        this.formData = {
          title,
          project: project_id,
          OT_date: moment(ot_date, DATE_FORMAT_SHORT),
          category,
          ot_type,
          start_time: moment(start_time, DATE_FORMAT_HM),
          end_time: moment(end_time, DATE_FORMAT_HM),
          description,
          ccMails: mail_cc?.map((user) => user._id),
          projectCode: project_code,
          assignee: getInfoStaff(assignee_ob),
        };
        const staffIds = [];
        if (staff && staff.length > 0) {
          staff.forEach((user) => {
            userSearches.push(user?.employee?.user_name);
            staffIds.push(user?.employee_id);
          });
        }
        if (mailList && mailList.length > 0) {
          mailList.forEach((user) => userSearches.push(user?.user_name));
        }
        this.formData = { ...this.formData, staff: staffIds };
        this.checkStartTime = {
          hours: parseInt(moment(start_time, DATE_FORMAT_HM).format("HH")),
          minutes: parseInt(moment(start_time, DATE_FORMAT_HM).format("mm")),
        };
        this.checkEndTime = {
          hours: parseInt(moment(end_time, DATE_FORMAT_HM).format("HH")),
          minutes: parseInt(moment(end_time, DATE_FORMAT_HM).format("mm")),
        };
      }
      const uniqueArr = [...new Set(userSearches)];
      this.onSearchStaff(uniqueArr.join(","));
      const { start_time, end_time } = this.formData;
      this.calculateDuration({ start_time, end_time });
      this.getAllListFile(this.data.id);
    },
    onValuesChange(_, values) {
      const { OT_date } = values;
      if (OT_date) {
        this.onChangeDate(OT_date);
      }
    },
    onChangeProject(value) {
      this.formRQ.setFieldsValue({ project: value });
      if (
        this.overtimeType === OT_TYPE_FIXED_CONFIG ||
        this.overtimeType === OT_TYPE_FLEXIBLE ||
        this.overtimeType === OT_TYPE_FIXED_CONFIG_IGNORE ||
        this.overtimeType === OT_TYPE_FLEXIBLE_IGNORE
      ) {
        this.formRQ.setFieldsValue({ pms: [] });
        if (value) {
          const project = this.projectListPermission.find((item) => item.project_id === value);
          if (project) {
            if (!this.isEdit) {
              this.formData.staff = [];
            }
            const { project_id, approver, project_code, pms } = project;
            this.projectSelected = project;
            this.formRQ.setFieldsValue({
              projectCode: project_code,
            });
            this.getRoleEmployeeProject(project_id);
            this.$store.dispatch("application/getEmployeeByProject", {
              projectId: project_id,
            });
            const pmList = [];
            if (pms && pms.length > 0) {
              pms.forEach((element) => {
                pmList.push(element.pm_user_name);
              });
            } else {
              pmList.push(approver);
            }
            if (pmList?.length > 0) {
              const uniqueArr = [...new Set(pmList)];
              this.onSearchPMList(uniqueArr.join(","));
              setTimeout(() => {
                this.formRQ.setFieldsValue({ pms: pmList });
              }, 200);
            }
          }
        } else {
          this.roleProject = "";
          this.formData.setFieldsValue({ pms: [] });
        }
      } else if (this.overtimeType === OT_TYPE_FIXED || this.overtimeType === OT_TYPE_FIXED_IGNORE) {
        if (value && this.allProjectList.length > 0) {
          const project = this.allProjectList.find((item) => item.project_id === value);
          if (project) {
            if (!this.isEdit) {
              this.formData.staff = [];
            }
            this.formRQ.setFieldsValue({ projectCode: project?.project_code });
            this.projectSelected = project;
          }
        }
      }
    },
    getRoleEmployeeProject(projectId) {
      http
        .get(`/tms/filters/project/${projectId}/role-employee?username=${this.userInfo.userName}`)
        .then((res) => {
          this.roleProject = res.data?.data;
          if (res.data?.data === ROLE_PROJECT_PM) {
            this.formData.staff = [this.userInfo?.userId];
          }
        })
        .catch((errors) => {
          this.$message.error(errors.response.data.message, 5);
        });
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    searchStaff(value, timeout) {
      if (
        this.overtimeType === OT_TYPE_FIXED_CONFIG ||
        this.overtimeType === OT_TYPE_FLEXIBLE ||
        this.overtimeType === OT_TYPE_FIXED_CONFIG_IGNORE ||
        this.overtimeType === OT_TYPE_FLEXIBLE_IGNORE
      ) {
        this.onSearchEmployeeByProject(value, timeout);
      } else if (this.overtimeType === OT_TYPE_FIXED || this.overtimeType === OT_TYPE_FIXED_IGNORE) {
        this.onSearchStaff(value, timeout);
      }
    },
    onSearchStaff(value, timeout) {
      let cloneVal = decodeURI(value);
      this.fetching = true;
      clearTimeout(this.timeoutAllStaff);
      this.timeoutAllStaff = setTimeout(() => {
        this.$store
          .dispatch("application/getEmployeeList", cloneVal)
          .then(() => {
            this.fetching = false;
          })
          .catch(() => {
            this.fetching = false;
          });
      }, timeout);
    },

    onSearchEmployeeByProject(value, timeout = 100, getAll = false) {
      if (this.projectSelected.project_id) {
        // let cloneVal = decodeURI(value);
        if (getAll || (value && value !== "" && value.length >= 3)) {
          const payload = {
            username: value,
            projectId: this.projectSelected.project_id,
          };
          this.fetching = true;
          clearTimeout(this.timeoutStaffByProject);
          this.timeoutStaffByProject = setTimeout(() => {
            this.$store
              .dispatch("application/getEmployeeByProject", payload)
              .then((res) => {
                this.fetching = false;
                if (parseInt(res.code) === 400) {
                  this.$message.error(res.message, 5);
                }
              })
              .catch(() => {
                this.fetching = false;
              });
          }, timeout);
        }
      } else {
        this.$message.error("Project is required");
      }
    },
    onSearchPMList(value) {
      http
        .get("/tms/filters/employee?filter=" + value)
        .then((res) => {
          console.log("🚀 ~ file: OvertimeModal.js:349 ~ .then ~ res", res);
          this.projectManagerList = res.data?.data ?? [];
        })
        .catch(() => {
          this.projectManagerList = [];
        });
    },

    onChangeStartTime(time) {
      this.formRQ.setFieldsValue({ start_time: time });
      if (time) {
        const { end_time } = this.formRQ.getFieldsValue(["end_time"]);
        if ((end_time && this.formatTimeOvertime(time).isBefore(this.formatTimeOvertime(end_time))) || !end_time) {
          this.checkStartTime = {
            hours: parseInt(moment(time).format("HH")),
            minutes: parseInt(moment(time).format("mm")),
          };
          this.calculateDuration(this.getTimeCalculateDuration());
        } else {
          this.$message.error("The start time must be before the end time");
        }
      } else {
        this.checkStartTime = {
          hours: 0,
          minutes: 0,
        };
        this.calculateDuration(this.getTimeCalculateDuration());
      }
    },

    onChangeEndTime(time) {
      this.formRQ.setFieldsValue({ end_time: time });
      if (time) {
        const { start_time } = this.formRQ.getFieldsValue(["start_time"]);
        if ((start_time && this.formatTimeOvertime(time).isAfter(this.formatTimeOvertime(start_time))) || !start_time) {
          this.checkEndTime = {
            hours: parseInt(moment(time).format("HH")),
            minutes: parseInt(moment(time).format("mm")),
          };
          this.calculateDuration(this.getTimeCalculateDuration());
        } else {
          this.$message.error("The end time must be after the start time");
        }
      } else {
        this.checkEndTime = {
          hours: 23,
          minutes: 59,
        };
        this.calculateDuration(this.getTimeCalculateDuration());
      }
    },
    getTimeCalculateDuration() {
      return this.formRQ.getFieldsValue(["start_time", "end_time"]);
    },
    calculateDuration(payload) {
      const { start_time, end_time } = payload;
      if (start_time && end_time) {
        this.durations.startTime = moment(start_time).format("HH:mm");
        this.durations.endTime = moment(end_time).format("HH:mm");
        let rangeTime = parseFloat(moment.duration(end_time.diff(start_time)).asHours().toFixed(2));
        this.durations.duration = rangeTime;
      } else {
        this.durations.duration = 0;
      }
    },
    formatTimeOvertime(date) {
      if (!date) return "";
      return moment(date.format(DATE_FORMAT_HM), DATE_FORMAT_HM);
    },
    onChangeDate(date) {
      if (!date) {
        this.formRQ.resetFields("category");
      } else {
        this.getCategory(date.format(DATE_FORMAT_V2));
      }
    },
    getCategory(otDate) {
      return http
        .get(`/tms/filters/date-type?date=${otDate}&employeeId=${this.userInfo.userId}`)
        .then((res) => {
          const category = res.data?.data?.name;
          this.formRQ.setFieldsValue({ category });
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },

    disabledHoursStart() {
      let hours = [];
      for (let index = this.checkEndTime.hours + 1; index < 24; index++) {
        hours.push(index);
      }
      if (this.checkEndTime.minutes === 0) {
        hours.push(this.checkEndTime.hours);
      }
      return hours;
    },

    disabledMinutesStart(hours) {
      let minute = [];
      if (hours === this.checkEndTime.hours) {
        for (let index = this.checkEndTime.minutes; index <= 59; index += 1) {
          minute.push(index);
        }
      }
      return minute;
    },
    disabledHours() {
      let hours = [];
      for (let index = 0; index < this.checkStartTime.hours; index++) {
        hours.push(index);
      }
      if (this.checkStartTime.minutes === 59) {
        hours.push(this.checkStartTime.hours);
      }
      return hours;
    },

    disabledMinutes(hours) {
      let minute = [];
      if (hours === this.checkStartTime.hours) {
        for (let index = 0; index <= this.checkStartTime.minutes; index += 1) {
          minute.push(index);
        }
      }
      return minute;
    },
    onCancel() {
      this.handleCancel();
      this.visibleModalOvertime = false;
      this.formRQ.resetFields();
    },
    onOk() {
      this.formRQ.validateFields((err, values) => {
        let otDate = moment(values.OT_date).format("YYYY-MM-DD");
        const { title, project, description, start_time, end_time, ccMails, ot_type, staff, OT_date } = values;
        if (!err) {
          if (this.fileList.length === 0 && (values.ot_type === "OT_FROM_HOME" || values.ot_type === "WORK_OUTSIDE")) {
            this.$message.error("Overtime request must have attach file !!!", 5);
          } else {
            this.isLoading = true;
            if (this.overtimeType === OT_TYPE_FIXED || this.overtimeType === OT_TYPE_FIXED_IGNORE) {
              const projectFind = this.allProjectList.find((item) => item.project_id === project);
              let payload = {
                title: title?.trim() ?? "",
                project_id: project,
                project_name: projectFind ? projectFind?.project_name : "",
                project_code: projectFind ? projectFind?.project_code : "",
                description: description?.trim() ?? "",
                start_time: `${otDate} ${moment(start_time).format("HH:mm:ss")}`,
                end_time: `${otDate} ${moment(end_time).format("HH:mm:ss")}`,
                mail_cc: ccMails,
                ot_date: otDate,
                ot_type: ot_type,
              };
              let temp = [];
              staff.forEach((element) => {
                temp.push({
                  approver_id: null,
                  status: 1,
                  employee_id: element,
                });
              });
              payload.staff = temp;
              if (!this.isEdit) {
                payload.comment = [];
                this.$store
                  .dispatch("overtime/createOTRequest", payload)
                  .then((res) => {
                    if (parseInt(res.code) === 200 || parseInt(res.code) === 201) {
                      this.handleUpload(res.data);
                      this.$message.success(res.message, 5);
                      this.getData();
                      this.onCancel();
                    } else {
                      this.isLoading = false;
                      temp = " ";
                      this.$message.error(res.message + temp, 5);
                    }
                  })
                  .catch((error) => {
                    this.isLoading = false;
                    this.$message.error(error.response.data.message, 5);
                  });
              } else {
                payload.id = this.data.id;
                this.$store
                  .dispatch("overtime/updateOTRequestData", payload)
                  .then((res) => {
                    // if (parseInt(res.code) === 200 || parseInt(res.code) === 201) {
                    if (res.validationResult.successful) {
                      this.$message.success(res.message, 5);
                      this.handleUpload(this.data.id);
                      this.getData();
                      this.onCancel();
                    } else {
                      this.isLoading = false;
                      this.$message.error(res.message, 5);
                    }
                  })
                  .catch((error) => {
                    this.isLoading = false;
                    this.$message.error(error.message, 5);
                  });
              }
              // this.formRQ.resetFields();
            } else {
              const payload = {
                title: title?.trim() ?? "",
                projectId: project,
                description: description?.trim() ?? "",
                ccMailList: ccMails,
                overtimeDate: OT_date.format(DATE_FORMAT_V2),
                requestType: ot_type,
                requesterIds: staff,
                startTime: start_time.format("HH:mm"),
                endTime: end_time.format("HH:mm"),
              };

              let check = false;
              if (!this.isEdit) {
                this.$store
                  .dispatch("overtime/createOTRequestFlexible", payload)
                  .then((res) => {
                    if (parseInt(res.code) === 201) {
                      check = true;
                      getMessages(res.message).forEach((msg) => {
                        this.$message.success(msg, 5);
                      });
                    } else if (parseInt(res.code) === 207) {
                      check = true;
                      const messages = getMessages(res.message);
                      if (messages && messages.length > 0) {
                        for (let i = 0; i < messages.length; i++) {
                          if (i === 0) {
                            this.$message.success(messages[i], 5);
                          } else {
                            this.$message.warn(messages[i], 5);
                          }
                        }
                      }
                    } else {
                      check = false;
                      this.isLoading = false;
                      getMessages(res.message).forEach((msg) => {
                        this.$message.error(msg, 5);
                      });
                    }
                    if (check) {
                      this.getData();
                      this.onCancel();
                      this.formData = {};
                      if (res.data && res.data.length > 0) {
                        res.data.forEach((requestId) => {
                          this.handleUpload(requestId);
                        });
                      }
                      this.formRQ.resetFields();
                    }
                  })
                  .catch((error) => {
                    this.isLoading = false;
                    getMessages(error.response.data.message).forEach((msg) => {
                      this.$message.error(msg, 5);
                    });
                  });
              } else {
                payload.id = this.data.id;
                this.$store
                  .dispatch("overtime/updateOTRequestFlexible", payload)
                  .then((res) => {
                    if (parseInt(res.code) === 200) {
                      check = true;
                      getMessages(res.message).forEach((msg) => {
                        this.$message.success(msg, 5);
                      });
                    } else if (parseInt(res.code) === 207) {
                      check = true;
                      const messages = getMessages(res.message);
                      if (messages && messages.length > 0) {
                        for (let i = 0; i < messages.length; i++) {
                          if (i === 0) {
                            this.$message.success(messages[i], 5);
                          } else {
                            this.$message.warn(messages[i], 5);
                          }
                        }
                      }
                    } else {
                      check = false;
                      this.isLoading = false;
                      getMessages(res.message).forEach((msg) => {
                        this.$message.error(msg, 5);
                      });
                    }
                    if (check) {
                      this.getData();
                      this.onCancel();
                      this.formData = {};
                      res.data &&
                        res.data.length > 0 &&
                        res.data.forEach((id) => {
                          this.handleUpload(id);
                        });
                      this.formRQ.resetFields();
                    }
                  })
                  .catch((error) => {
                    this.isLoading = false;
                    getMessages(error.response.data.message).forEach((msg) => {
                      this.$message.error(msg, 5);
                    });
                  });
              }
            }
          }
        }
      });
    },

    // file choosen
    beforeUpload(file) {
      const result = beforeUploadFile(file);
      if (result.isValid) {
        this.fileList = [...this.fileList, file];
      } else {
        this.$message.error(result.message, 5);
      }
      return false;
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      this.deleteFile(this.data.id, file.name);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    handleUpload(id) {
      const { fileList, overtimeType } = this;
      if (
        overtimeType === OT_TYPE_FIXED_CONFIG ||
        overtimeType === OT_TYPE_FLEXIBLE ||
        overtimeType === OT_TYPE_FIXED_CONFIG_IGNORE ||
        overtimeType === OT_TYPE_FLEXIBLE_IGNORE
      ) {
        if (fileList.length > 0) {
          const formData = new FormData();
          fileList.forEach((file) => {
            formData.append("file", file);
          });
          http
            .post(`/tms/overtime-management/v2/${id}/upload?file`, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((res) => {
              if (res.status === 200) {
                this.$message.success("Upload file success");
                fileList.splice(0, fileList.length);
              } else {
                this.$message.error("Upload file failed");
              }
              return res.data;
            })
            .catch((err) => {
              throw err;
            });
        }
      } else if (overtimeType === OT_TYPE_FIXED || overtimeType === OT_TYPE_FIXED_IGNORE) {
        const formData = new FormData();

        fileList.forEach((file) => {
          formData.append("file", file);
        });
        http
          .post(`/tms/request-management/overtime/${id}/upload?file`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            this.$message.success("Success");
            fileList.splice(0, fileList.length);
            return res.data;
          })
          .catch((err) => {
            throw err;
          });
      }
    },
    getAllListFile(id) {
      const { fileList, overtimeType } = this;
      if (
        overtimeType === OT_TYPE_FIXED_CONFIG ||
        overtimeType === OT_TYPE_FLEXIBLE ||
        overtimeType === OT_TYPE_FIXED_CONFIG_IGNORE ||
        overtimeType === OT_TYPE_FLEXIBLE_IGNORE
      ) {
        http
          .get(`/tms/overtime-management/v2/${id}/get-all-file-upload`)
          .then((res) => {
            if (res.data) {
              let tempData = res.data;
              tempData.forEach((record) => {
                fileList.push(record);
              });
              if (fileList.length > 0) {
                this.isAvaiableToDownLoad = true;
              } else {
                this.isAvaiableToDownLoad = false;
              }
              return tempData;
            }
          })
          .catch((err) => {
            throw err;
          });
      } else {
        http
          .get(`/tms/request-management/overtime/get-all-file-list?id=` + id)
          .then((res) => {
            if (res.data) {
              let tempData = res.data;
              tempData.forEach((record) => {
                fileList.push(record);
              });
              if (fileList.length > 0) {
                this.isAvaiableToDownLoad = true;
              } else {
                this.isAvaiableToDownLoad = false;
              }
              return tempData;
            }
          })
          .catch((err) => {
            throw err;
          });
      }
    },
    deleteFile(id, name) {
      if (
        this.overtimeType === OT_TYPE_FIXED_CONFIG ||
        this.overtimeType === OT_TYPE_FLEXIBLE ||
        this.overtimeType === OT_TYPE_FIXED_CONFIG_IGNORE ||
        this.overtimeType === OT_TYPE_FLEXIBLE_IGNORE
      ) {
        return http
          .delete(`/tms/overtime-management/v2/${id}/${name}`)
          .then((res) => {
            if (res.status === 200) {
              this.$message.success(res.data);
              if (this.fileList.length > 0) {
                this.isAvaiableToDownLoad = true;
              } else {
                this.isAvaiableToDownLoad = false;
              }
              return true;
            } else false;
          })
          .catch((err) => {
            throw err;
          });
      } else {
        http
          .get(`/tms/request-management/overtime/${id}/delete-file?name=` + name)
          .then((res) => {
            this.$message.success(res.data);
            if (this.fileList.length > 0) {
              this.isAvaiableToDownLoad = true;
            } else {
              this.isAvaiableToDownLoad = false;
            }
            return res.data;
          })
          .catch((err) => {
            throw err;
          });
      }
    },

    handleDownload() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        const { fileList } = this;
        fileList.forEach((file) => {
          http
            .get(`/tms/request-management/overtime/${this.data.id}/download?name=` + file.name, {
              responseType: "blob",
            })
            .then((res) => {
              downloadFile(res.data, file.name);
              return res.data;
            })
            .catch((err) => {
              throw err;
            });
        });
      }, 500);
    },
    disableWeekends(date) {
      return disableWeekendCommon(
        date.format(DATE_FORMAT_SHORT),
        this.lastTimesheet?.last_timesheet_period_end_date,
        10,
        DATE_FORMAT_SHORT,
        this.timeServer
      );
    },
    getAssignee() {
      const payload = {
        username: this.userInfo.userName,
        date: moment(new Date()).format(DATE_FORMAT_V2),
      };
      return http
        .get(`/tms/filters/get-approver-for-user${convertObjectToParams(payload)}`)
        .then((res) => {
          this.formData = {
            ...this.formData,
            assignee: getInfoStaff(res.data),
          };
        })
        .catch((err) => {
          throw err;
        });
    },
    getStaffPlaceholder() {
      const pmList = this.formRQ.getFieldValue("pms");
      if (pmList && pmList.length > 0) {
        const listPM = this.projectManagerList
          ?.filter((employee) => pmList.includes(employee.user_name))
          .map((employee) => getInfoStaff(employee))
          .slice(3);
        return listPM;
      }
      return [];
    },
  },
};
